import React, { useState } from "react";
// import blacklogo from "../../../assets/images/blacklogo.png";
import blacklogo from "../../../assets/images/techifyblack.svg";
import { Formik, Form, Field } from "formik";
import MainButton from "../../shared/Button";
import AuthInput from "../../shared/authinput";
import { Checkbox } from "@mui/material";
// import UserInfoPopup from "./UserInfoPopup";
import {
  AdminLoginMain,
  LoginBox,
  HeaderLogo,
  SignIntext,
  FormMain,
  ForgotPasswordMain,
  // ForgotPasswordLink,
  StyledFormControlLabel,
} from "./styles/AdminLoginStyle";
import { validationSchema } from "../../../helpers/validations/admin/LoginValidaction";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { loginSuccess } from "../../../redux/slice/user/UserSlice";
import { AdminLoginApi } from "../../../services/admin/auth";

const AdminLogin = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [Loading, setLoading] = useState(false);

  const handleSubmit = async (values, { resetForm }) => {
    const { password, email } = values;
    const userObj = {
      password,
      email,
    };
    const resp = await AdminLoginApi(setLoading, userObj);
    if (resp?.status === 200) {
      const { user } = resp?.data;
      dispatch(loginSuccess(user));
      navigateBasedOnRoleAndAbilities(user);
      resetForm();
    }
  };

  const navigateBasedOnRoleAndAbilities = (user) => {
    const { role, abilities } = user;

    if (role === "admin") {
      navigate("/admin/customers");
    } else if (role === "agent") {
      const navigationMap = {
        Customers: "/admin/customers",
        Drivers: "/admin/drivers",
        Dispatches: "/admin/dispatches",
        "Job Histories": "/admin/job-history",
        Accountings: "/admin/accounting",
        Chats: "/admin/chat",
        Agents: "/admin/agents",
      };

      for (const abilityKey in navigationMap) {
        if (abilities.includes(abilityKey)) {
          navigate(navigationMap[abilityKey]);
          return; // Terminate the loop after navigation
        }
      }

      // Default navigation if no matching ability found
      navigate("/404"); // Adjust the route as needed
    }
  };

  return (
    <>
      {/* <UserInfoPopup /> */}
      <AdminLoginMain>
        <LoginBox>
          <HeaderLogo>
            <h6>Welcome !</h6>
            <img src={blacklogo} alt="admin app logo" />
          </HeaderLogo>
          <SignIntext>
            <h6>Sign in to </h6>
            <span>Admin Panel</span>
          </SignIntext>

          <FormMain>
            <Formik
              initialValues={{
                email: "admin@admin.com",
                password: "passwordAdmin",
              }}
              validationSchema={validationSchema}
              onSubmit={handleSubmit}
            >
              {(formik) => (
                <Form autocomplete="off">
                  <Field
                    type="email"
                    name="email"
                    label="Email"
                    placeholder="Enter your email"
                    component={AuthInput}
                  />
                  <Field
                    type="password"
                    name="password"
                    label="Password"
                    placeholder="Enter your password"
                    component={AuthInput}
                    showIcon={true}
                  />

                  <ForgotPasswordMain>
                    <StyledFormControlLabel
                      control={<Checkbox />}
                      label="Rememebr me"
                    />
                    {/* <ForgotPasswordLink to="#">
                      Forgot Password ?
                    </ForgotPasswordLink> */}
                  </ForgotPasswordMain>

                  <MainButton
                    type="submit"
                    label="Login"
                    MT="20"
                    isLoading={Loading}
                  />
                </Form>
              )}
            </Formik>
          </FormMain>
        </LoginBox>
      </AdminLoginMain>
    </>
  );
};

export default AdminLogin;
